{
  "title": "如何審核競賽建立申請",
  "description": "審核使用者提出的競賽建立申請，決定核准、退回要求補充，或拒絕。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該筆申請進入對應的審核結果狀態；若核准，系統會自動建立競賽並將申請人設為第一位管理員。",
  "roleNote": "平台管理員",
  "prerequisites": ["具備競賽申請審核相關權限"],
  "pathLabel": "平台管理 → 競賽建立申請",
  "steps": [
    {
      "title": "1. 開啟待審核申請清單",
      "description": "清單依狀態分頁呈現，可查看「已送出」「審核中」「已要求補充」等狀態的申請。"
    },
    {
      "title": "2. 查看申請詳情",
      "description": "點入單一申請可查看完整內容：競賽名稱、網址代稱、主辦單位、聯絡人、簡介、時區、預計時程與參賽人數、是否需要評審、是否雙輪次、是否蒐集未成年學生資料。"
    },
    {
      "title": "3. 標記開始審核（選填）",
      "description": "可將申請標記為「審核中」，這只是狀態上的標示，方便團隊協作時知道這筆申請有人正在處理，不影響後續是否能核准／拒絕。"
    },
    {
      "title": "4a. 核准申請",
      "description": "確認資訊無誤後點選「核准」並填寫原因（必填），系統會自動建立競賽（含基本設定與第一個輪次），並將申請人設為該競賽的 competition_admin。"
    },
    {
      "title": "4b. 退回要求補充",
      "description": "若資訊不完整或需要澄清，點選「要求補充」並填寫原因（必填），申請人會看到您填寫的原因並可修改後重新送出。"
    },
    { "title": "4c. 拒絕申請", "description": "若確定不核准，點選「拒絕」並填寫原因（必填）。" }
  ],
  "afterward": [
    "核准後系統自動建立競賽，申請人可立即以主辦方管理員身分登入操作該競賽",
    "退回要求補充或拒絕後，該筆申請的原因會提供給申請人查看",
    "所有審核決定皆需填寫原因，並會寫入平台稽核紀錄"
  ],
  "nextSteps": "核准後，可提醒申請人參考「如何建立競賽輪次並設定時程」等操作手冊完成後續設定。",
  "faq": [
    {
      "q": "一定要先標記「審核中」才能核准或拒絕嗎？",
      "a": "不需要。「已送出」「審核中」「已要求補充」三種狀態的申請都可以直接核准或拒絕，「審核中」只是方便團隊協作辨識目前處理進度的標示，不是核准／拒絕的必要前置步驟。"
    },
    {
      "q": "核准後我還需要自己去建立這場競賽嗎？",
      "a": "不需要。核准即觸發自動化建立流程，系統會直接產生競賽（含基本設定與第一個輪次）並將申請人設為第一位管理員，您不需要另外執行任何建立動作。"
    },
    {
      "q": "已經核准的申請可以重複核准嗎？",
      "a": "可以安全地重複呼叫核准，若該申請已經核准且對應競賽已建立，系統會直接回傳既有的建立結果，不會重複建立第二場競賽或報錯。"
    }
  ]
}
